import VueRouter from 'vue-router'
import application from './application.router'
// import home from './home.router'
// import my from './my.router'
// import project from './project.router'
// import monitor from './monitor.router'
// import store from '@/store'
// import {getToken} from '@/libs/util'
// import BimView from './bim.router'
import {Toast} from 'vant';
import { autologin } from "../utils/autoLogin";

const routes = [
    {
        path: '/',
        name: 'index',
        // redirect: '/home',
        // redirect: '/project',
        component: () => import(/* webpackChunkName: "index" */ '../views/index.vue'),
        children: [
            // ...home,
            // ...monitor,
            // ...project,
            ...application,
            // ...my,
            // ...BimView
        ]
    },
    // {
    //     path: '/login',
    //     name: 'login',
    //     component: () => import('../views/login/login.vue'),
    // },
    // {
    //     path: '/posts',
    //     name: 'posts',
    //     component: () => import('../views/login/posts.vue'),
    // },
    // {
    //     path: '/forget',
    //     name: 'forget',
    //     component: () => import('../views/login/forget.vue'),
    // },
    // {
    //     path: '/updatePwd',
    //     name: 'updatePwd',
    //     component: () => import('../views/login/update.vue'),
    // },
    // {
    //     path: '/modifyAccount',
    //     name: 'modifyAccount',
    //     component: () => import('../views/login/modifyAccount.vue'),
    // },
    {
        path: '*',
        name: 'notfund',
        component: () => import('../views/404/404.vue'),
    },
    {
        path: '/webview',
        name: 'webview',
        component: () => import('../views/Webview/index.vue'),
    }
]
const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error)
}
const router = new VueRouter({
    mode: 'history',
    routes
})

router.beforeEach(async (to, from, next) => {
    console.log(location.href, 'href')
    console.log('userId', to.query.userId)
    console.log('4', to)
    console.log('更新')
    //const token = window.localStorage.getItem('vuex') ? JSON.parse(window.localStorage.getItem('vuex')).user.token : '';
     if(to.query.userId) {
        sessionStorage.setItem('userId', to.query.userId)
        await autologin(to.query.userId)
        console.log('2')
        next()
    } else {
        console.log('3')
        next()
    }
})
export default router
